import React, { useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Popper from "@mui/material/Popper";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// ✅ Helper: safely extract a plain string from name field
const extractName = (name) => {
  if (!name) return "";
  if (typeof name === "string") return name;
  if (typeof name === "object") return name.value || name.name || "";
  return String(name);
};

export default function DropDownCategory({
  data = [],
  name,
  setFilterData,
  filterData,
  selectedOptions,
  setSelectedOptions,
}) {
  const [inputValue, setInputValue] = React.useState("");
  const [filteredFilms, setFilteredFilms] = React.useState(data);

  useEffect(() => {
    if (Array.isArray(data)) {
      setFilteredFilms(data);
    } else {
      setFilteredFilms([]);
    }
  }, [data]);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    setFilteredFilms(
      data?.filter((item) =>
        extractName(item?.name)
          .toLowerCase()
          .includes(newInputValue?.toLowerCase()),
      ),
    );
  };

  const handleChange = (event, newValue) => {
    // ✅ extractName use karo taaki array of plain strings mile
    const valData = newValue.map((ele) => extractName(ele.name));
    setFilterData({ ...filterData, category: valData });
    setSelectedOptions(newValue);
  };

  useEffect(() => {
    if (Array.isArray(filterData.category) && data.length) {
      const matched = data.filter((item) =>
        filterData.category.includes(extractName(item.name)),
      );
      setSelectedOptions(matched);
    }
  }, [filterData.category, data]);

  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={filteredFilms}
      disableCloseOnSelect
      // ✅ getOptionLabel ko bhi fix kiya — object aane par crash nahi karega
      getOptionLabel={(option) => extractName(option?.name)}
      sx={{
        "& .MuiAutocomplete-inputRoot": {
          flexWrap: "nowrap",
          padding: "3px 8px",
          borderRadius: "40px",
          paddingRight: "70px !important",
        },
        "& .MuiAutocomplete-tag": {
          marginRight: "4px",
        },
      }}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      value={selectedOptions}
      onChange={handleChange}
      PopperComponent={(props) => (
        <Popper
          {...props}
          placement="bottom-start"
          style={{ maxHeight: "200px", overflowY: "hidden" }}
        />
      )}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        // ✅ Yahan bhi extractName use kiya — object directly render nahi hoga
        const label = extractName(option?.name);
        return (
          <li key={key} {...optionProps} style={{ whiteSpace: "normal" }}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {label || "Unknown"}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={name}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: { top: "-5px" },
          }}
        />
      )}
      renderTags={(value, getTagProps) => {
        const MAX_CHIPS = 1;
        const moreCount = value.length - MAX_CHIPS;
        return (
          <>
            {value.slice(0, MAX_CHIPS).map((option, index) => (
              <Chip
                key={index}
                // ✅ Chip label bhi extractName se safe string lega
                label={extractName(option.name)}
                sx={{
                  maxWidth: "80px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  marginRight: "4px",
                  borderRadius: "12px",
                }}
                {...getTagProps({ index })}
              />
            ))}
            {moreCount > 0 && (
              <Chip
                label={`+${moreCount} more`}
                sx={{
                  backgroundColor: "#e0e0e0",
                  borderRadius: "12px",
                  height: "28px",
                }}
              />
            )}
          </>
        );
      }}
    />
  );
}
